import React from "react";
import { Container, Typography, Button, Stack } from "@mui/material";

const Simulations = ({ setView }) => {
	  const buttons = [
		      { label: "Serve JD at EverTrue Facility (MCI)", view: "training" },
		      { label: "Serve Aunt Cassie at Guardian Primary Care (Middle Stage)", view: "doctor" },
		      { label: "Serve Ben, a hard-to-deal-with family member visiting EverTrue Facility (Spanish speaking)", view: "family" },
		      { label: "Serve Aunt Cassie, helping her Age at Simulations (Middle Stage)", view: "ageathome" },
		      { label: "MCI Standard Visit (angry, stuck on empathetic answer to time) Level 3 Test", view: "ageathome" },
		      { label: "Advanced Dementia Ride bus on Rainy day (and initially frustrated) Level 2 Test", view: "ageathome" },
		      { label: "Advanced Dementia Ride bus on Rainy day (and initially frustrated) Level 2 Test", view: "ageathome" },
		    ];

	  return (
		      <Container maxWidth="md" sx={{ mt: 4 }}>
		        <Typography variant="h4" gutterBottom>
		          Simulations
		        </Typography>
		        <Stack spacing={2}>
		          {buttons.map(({ label, view, variant }) => (
				            <Button
				              key={view}
				              variant={variant || "text"}
				              onClick={() => setView(view)}
				            >
				              {label}
				            </Button>
				          ))}
		        </Stack>
		      </Container>
		    );
};

export default Simulations;

